<template>
  <div class="myhome-bookmarks" :class="{ 'myhome-bookmarks--expanded': isDropdownOpen }">
    <router-view
      v-if="bookmarksLoaded && user && user.authenticated"
      :bookmark-types="bookmarkTypes"
      :user="user"
      @dropdown-toggled="checkDropdowns()"
    ></router-view>
    <Loader v-else></Loader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/elements/Loader";

export default {
  name: "BookmarksHome",
  components: { Loader },
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  computed: {
    ...mapGetters(["user", "config", "bookmarksLoaded"]),
    bookmarkTypes() {
      const color = this.user && this.user.targetCss ? this.user.targetCss.borderMod : "";
      const links = [];
      if (!this.user.parent) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "bookmarks-resources",
          colorMod: color,
          name: "Risorse",
          url: null,
          route: "bookmarks-resources",
        });
      }
      links.push({
        action: this.openRoute,
        active: this.$route.name === "bookmarks-dealive",
        colorMod: color,
        name: "Articoli Dlive",
        url: null,
        route: "bookmarks-dealive",
      });
      if (!this.user.student && !this.user.parent) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "bookmarks-events",
          colorMod: color,
          name: "Corsi di formazione",
          url: null,
          route: "bookmarks-events",
        });
      }
      return links;
    },
  },
  methods: {
    ...mapActions(["fetchUser"]),
    openRoute(item) {
      this.$router.push({ name: item.route });
    },
    checkDropdowns() {
      this.$nextTick(() => {
        const cardList = Array.from(document.querySelectorAll(".myhome-bookmarks .dea-card-resource"));
        const cardFiltered = cardList.filter(el => {
          return !el.getAttribute("data-test-id").includes("undefined");
        });
        const lastCard = cardFiltered.pop();
        const lastButton = lastCard.querySelector(".dea-card-resource__share-dropdown");
        this.isDropdownOpen = lastButton && window.getComputedStyle(lastButton).getPropertyValue("display") === "block";
        this.$nextTick(() => {
          if (this.isDropdownOpen) lastButton.scrollIntoView({ behavior: "smooth", block: "start", inline: "end" });
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$myhome-bookmarks-margin-bottom: 280px;

.myhome-bookmarks {
  padding-top: $space-base;

  &--expanded {
    margin-bottom: $myhome-bookmarks-margin-bottom !important; //sass-lint:disable-line no-important
  }
}

.bookmarks {
  &__header {
    @include media("<=m") {
      flex-direction: column;
    }
    display: flex;
    margin: 0 0 $space-base;

    .dea-input {
      label {
        margin: 0;
      }
    }
  }

  &__title {
    flex-grow: 1;
    margin: 0;
  }

  &__sidebar {
    @include media("<=m") {
      margin-bottom: $space-large;
    }
  }
}

.dea-button.dea-button--hide-filters,
.dea-button.dea-button--show-filters {
  @include media(">s") {
    display: none !important; //sass-lint:disable-line no-important
  }
}

.dea-input.dea-input--margin-responsive {
  @include media("<=m") {
    display: flex;
    justify-content: flex-end;
    margin-top: $space-base;
    width: 100%;

    .dea-input__wrapper {
      max-width: $dea-size-xxx-large;
    }
  }
}
</style>
